import CONFIG from '../../config';

const actions = {
  // generateOtp
  generateOtp(context, params) {
    context.commit('ADD_LOG', { request: 'generateOtp' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('generateOtp', params.applicationId), {},
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: localStorage.getItem('token'),
            }
          }
        )
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'generateOtp' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'generateOtp' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  submitOtp(context, params) {
    context.commit('ADD_LOG', { request: 'submitOtp' });
    context.commit("udyamList", null);
    return new Promise((resolve, reject) => {
      this.axios
        .post(CONFIG.getEndpoint('submitOtp', params.applicationId),
          {
            request_id: params.request_id,
            otp: params.otp
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: localStorage.getItem('token'),
            }
          }
        )
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'submitOtp' });
          context.commit("udyamList", response.data);
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'submitOtp' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  },
  submitUdyamDetails(context, params) {
    context.commit('ADD_LOG', { request: 'submitUdyamDetails' });
    return new Promise((resolve, reject) => {
      this.axios
        .post(
          CONFIG.getEndpoint('submitUdyamDetails', params.applicationId),
          {
            udyam_reg_no: params.udyamNumber,
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: localStorage.getItem('token'),
            }
          }
        )
        .then((response) => {
          context.commit('REMOVE_LOG', { request: 'submitUdyamDetails' });
          resolve(response.data);
        })
        .catch((err) => {
          context.commit('REMOVE_LOG', { request: 'submitUdyamDetails' });
          context.dispatch('resolveError', { err })
            .catch((resolvedError) => {
              reject(resolvedError);
            });
        });
    });
  }
};
export default actions;
